import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

/**
 * Auth page - redirects to the appropriate landing page with auth modal open
 * Preserves product parameter for product-specific landing pages
 */
const Auth = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const product = searchParams.get("product");
  const code = searchParams.get("code");

  useEffect(() => {
    // Build redirect URL based on product
    let redirectPath = "/";
    if (product === "mindcotine") {
      redirectPath = "/mindcotine";
    } else if (product === "relief" || product === "mindco-relief") {
      // Support both legacy 'relief' and canonical 'mindco-relief' product parameter
      redirectPath = "/mindco-relief";
    }

    // Add auth=true to open the modal, and preserve invite code if present
    const params = new URLSearchParams();
    params.set("auth", "true");
    if (code) {
      params.set("code", code);
    }

    navigate(`${redirectPath}?${params.toString()}`, { replace: true });
  }, [navigate, product, code]);

  return null;
};

export default Auth;
